import { render } from "./ImgPreviewer.vue?vue&type=template&id=1ecb7141&ts=true"
import script from "./ImgPreviewer.vue?vue&type=script&lang=ts"
export * from "./ImgPreviewer.vue?vue&type=script&lang=ts"

import "./ImgPreviewer.vue?vue&type=style&index=0&id=1ecb7141&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__